import { shop } from '@/commonTypes';
import PageCardHeader from '@/components/general/PageCard/PageCardHeader';
import MainIcons from '@/icons/main';
import React from 'react';
import styles from '../styles.module.css';

import dynamic from 'next/dynamic';
const AppMap = dynamic(() => import('@/components/general/AppMap'), {
  ssr: false,
  loading: () => <div style={{ height: '600px', width: '100%' }} />, // یا هر placeholder دلخواه
});

export default function ShopAddress({ shop, className = '' }: { shop?: shop; className?: string }) {
  // [35.747288, 51.303524]
  const position = [shop?.location?.latitude, shop?.location?.longitude];
  const list = [
    {
      id: 1,
      title: 'آدرس',
      text: `${shop?.city?.name} ${shop?.address}`,
      icon: <MainIcons.locationIcon fill="var(--brand-deep)" />,
      backgroundIcon: 'var(--tag-bg)',
    },
    {
      id: 2,
      title: 'ساعت کاری',
      text: `${shop?.openTime}`,
      icon: <MainIcons.clockIcon fill="var(--danger)" />,
      backgroundIcon: 'var(--danger-bg)',
    },
    {
      id: 3,
      title: 'تلفن',
      text: `${shop?.phone}`,
      icon: <MainIcons.clockIcon fill="var(--green)" />,
      backgroundIcon: 'var(--green-bg)',
    },
  ];
  return (
    <div className={`${styles.shopAddressContainer} ${className}`}>
      {list?.map((item, index) => (
        <PageCardHeader
          key={index}
          title={item?.title}
          text={item?.text}
          icon={item?.icon}
          backgroundIcon={item?.backgroundIcon}
          //   className={`${styles.card}`}
          //   headClass={`${styles.headClass}`}
          textClass={styles.textClassAddress}
          titleClass={styles.titleClassAddress}
          //   iconClass={`${styles.iconClass}`}
        />
      ))}
      <div className={`${styles.google_map}`}>
        <AppMap
          position={position}
          setPosition={null}
          showMyLocation={false}
          goToUserLocation={false}
          thisLocationText="مکان فروشگاه"
        />
      </div>
    </div>
  );
}
